import React from 'react';
import { Chip } from '@mui/material';

const messages = {
  SITE_BALANCE_STALE: 'Баланс изменился. Проверьте новый остаток и подтвердите корректировку заново.',
  SITE_INSUFFICIENT_BALANCE: 'На этом счёте сайта недостаточно средств.',
  INVALID_LOGIN: 'Укажите точный логин без пробелов по краям, не длиннее 128 символов.',
  INVALID_CRYPTO_ADDRESS: 'Адрес не прошёл проверку сети или контрольной суммы. Нужен публичный адрес BTC/LTC основной сети.',
  CRYPTO_ADDRESS_ALREADY_USED: 'На адресе уже есть транзакции. Добавьте свежий адрес, выделенный только для V4.',
  CRYPTO_ADDRESS_IN_LEGACY: 'Адрес уже находится в legacy-пуле. Для V4 нужны отдельные адреса.',
  DUPLICATE_CRYPTO_ADDRESS: 'Адрес повторяется в списке либо уже добавлен в V4.',
  CRYPTO_CHAIN_UNAVAILABLE: 'Не удалось проверить блокчейн. Повторите проверку позже.',
  CRYPTO_CHAIN_RATE_LIMITED: 'Публичные API блокчейна ограничили частоту запросов. V4 переключается между источниками; повторите позже.',
  CRYPTO_CHAIN_TIMEOUT: 'API блокчейна не ответил вовремя. Повторите проверку позже.',
  CRYPTO_CHAIN_DNS_FAILED: 'Не удалось разрешить адрес API блокчейна. Проверьте DNS и сеть сервера.',
  CRYPTO_CHAIN_TLS_FAILED: 'Не удалось проверить TLS-сертификат API блокчейна.',
  CRYPTO_CHAIN_RESPONSE_INVALID: 'API блокчейна вернул неподдерживаемый ответ. Повторите позже.',
  CRYPTO_CHAIN_ADDRESS_MISMATCH: 'API блокчейна вернул данные другого адреса. Проверка отклонена.',
  CRYPTO_RATE_UNAVAILABLE: 'Курс BTC/LTC к рублю недоступен или устарел.',
  INTERNAL_RESOURCE_UNAVAILABLE: 'Нет доступных ресурсов процессинга. Для BTC/LTC включите адреса в пуле.',
  INTERNAL_AMOUNT_RANGE_EXHAUSTED: 'Для этой суммы исчерпан диапазон уникальных добавок на адресах. Расширьте amountAdjustmentMaxUnits или добавьте адрес.',
  CRYPTO_ADDRESS_HAS_UNSETTLED_HISTORY: 'На адресе есть старая одноразовая заявка без подтверждённой оплаты. Переводить такой адрес в новый режим пока нельзя.',
  CRYPTO_ADDRESS_ALREADY_ALLOCATED: 'Адрес уже выключен либо закреплён по прежней одноразовой схеме. Обновите список.',
  ACCOUNT_REVISION_CONFLICT: 'Остаток изменился. Обновите данные и подтвердите операцию заново.',
  INSUFFICIENT_PROCESSING_DEBT: 'Сумма погашения превышает текущий долг процессинга.',
  INVALID_SETTLEMENT_AMOUNT: 'Укажите положительные суммы RUB (до 2 знаков) и USDT (до 8 знаков).',
  SETTLEMENT_ALREADY_REVERSED: 'Это погашение уже отменено. Обновите журнал.',
  INVALID_REVERSAL: 'Не найдена подходящая запись погашения для отмены.',
  V4_NOT_PREPARED: 'V4 ещё не подготовлена. Откройте вкладку «Система».',
  V4_INDEXES_REQUIRED: 'Необходимо подготовить коллекции и индексы V4.',
  V4_TRANSACTIONS_REQUIRED: 'Для V4 нужен MongoDB replica set. Работа без транзакций запрещена.',
  V4_DATABASE_UNAVAILABLE: 'Нет соединения с базой данных.',
  V4_CONFIGURATION_INVALID: 'Проверьте конфигурацию V4 на сервере.',
  V4_SECRET_UNAVAILABLE: 'Ключ доступа недоступен. Создайте его в панели или перенесите текущий ключ из окружения в БД.',
  REVISION_CONFLICT: 'Настройки уже изменены. Обновите список и повторите редактирование.',
  VERSION_CONFLICT: 'Ордер уже изменён другим обработчиком. Обновите карточку перед действием.',
  ROUTE_DEPENDENCY_DISABLED: 'Сначала включите выбранные процессинг и тариф.',
  CURRENCY_PRECISION_CONFLICT: 'Точность этой валюты отличается от уже используемой в системе.',
  INVALID_PROVIDER_OPTIONS: 'Параметры провайдера не соответствуют выбранной интеграции.',
  INVALID_SECRET_REFERENCE: 'Выберите сохранённый ключ подходящего назначения. Ключи документов нельзя использовать для процессингов.',
  WEBHOOK_SECRET_REQUIRED: 'Для этого процессинга нужен отдельный секрет входящих уведомлений.',
  CALLBACK_URL_REQUIRED: 'Перед включением укажите адрес колбека процессинга.',
  UNSUPPORTED_METHOD: 'Выбранный процессинг не поддерживает этот метод или валюту.',
  INVALID_TRANSITION: 'Этот переход статуса недопустим.',
  PAID_ORDER_IMMUTABLE: 'Оплаченный ордер нельзя отменить или вернуть в ожидание.',
  ORDER_ALREADY_TERMINAL: 'Ордер уже завершён.',
  UNRESOLVED_CREATION: 'Сначала необходимо выяснить результат создания платежа у провайдера.',
  RECEIPT_RETRY_NOT_ALLOWED: 'Повторная отправка этого документа небезопасна или уже выполняется.',
  RECEIPT_DISPUTE_REQUIRED: 'Для видео у этого провайдера должна быть открыта апелляция.',
  RECEIPT_UNSUPPORTED: 'Процессинг не поддерживает передачу этого документа.',
  RECEIPT_UNSUPPORTED_MEDIA: 'Формат или содержимое файла не поддерживается.',
  RECEIPT_TOO_LARGE: 'Файл превышает допустимый размер.',
  RECEIPT_LINKS_UNCONFIGURED: 'На сервере не настроен публичный адрес защищённых ссылок на документы.',
  RECEIPT_LINK_SECRET_UNAVAILABLE: 'На сервере не настроен ключ подписи ссылок на документы.',
  RECEIPT_STORAGE_FAILED: 'Хранилище документов недоступно. Проверьте настройки сервера.',
  CALLBACK_RETRY_NOT_ALLOWED: 'Callback сейчас отправляется или его состояние изменилось. Обновите карточку. Для повтора доставленного события используйте «Повторить последний callback».',
  LOOKUP_UNSUPPORTED: 'Провайдер не поддерживает поиск платежа. Требуется ручная проверка.',
  POLL_UNSUPPORTED: 'Для этого провайдера нет автоматической проверки статуса.',
  NO_ELIGIBLE_ROUTE: 'Не найден подходящий включённый маршрут.',
  INVALID_FIELDS: 'Проверьте заполнение полей формы.',
  FORBIDDEN: 'Недостаточно прав. Раздел V4 доступен администратору.',
  UNAUTHORIZED: 'Сессия завершена. Войдите в панель повторно.',
};

export function errorMessage(error) {
  if (error?.response?.status === 401) return messages.UNAUTHORIZED;
  if (error?.response?.status === 403) return messages.FORBIDDEN;
  const code = error?.response?.data?.error?.code || error?.code;
  if (messages[code]) return messages[code];
  if (/^CRYPTO_CHAIN_HTTP_[1-5]\d\d$/.test(code || '')) return `API блокчейна ответил ошибкой ${code.slice(-3)}. V4 попробует резервный источник; повторите позже.`;
  if (error?.response?.status === 404) return 'Не найден ресурс или API V4 ещё не подключён на сервере.';
  if (error?.response?.status === 503) return 'V4 временно недоступна. Проверьте вкладку «Система».';
  if (code && /^[A-Z][A-Z0-9_]{1,100}$/.test(code)) return `Не удалось выполнить действие (${code}).`;
  return 'Не удалось выполнить запрос. Проверьте соединение и попробуйте снова.';
}

export function formatMoney(units, scale = 2, currency = '') {
  if (!Number.isInteger(scale) || scale < 0 || scale > 8 || (typeof units === 'number' && !Number.isSafeInteger(units))) return '—';
  const value = String(units ?? '');
  if (!/^-?\d+$/.test(value) || value.length > 36) return '—';
  const negative = value.startsWith('-');
  const digits = value.replace(/^-/, '').replace(/^0+(?=\d)/, '').padStart(scale + 1, '0');
  const whole = (scale ? digits.slice(0, -scale) : digits).replace(/\B(?=(\d{3})+(?!\d))/g, ' ');
  return `${negative ? '−' : ''}${whole}${scale ? `,${digits.slice(-scale)}` : ''}${currency ? ` ${currency}` : ''}`;
}

export function decimalMoney(value, currency = '') {
  const match = /^(\d+)(?:\.(\d{1,8}))?$/.exec(String(value ?? ''));
  return match ? formatMoney(`${match[1]}${match[2] || ''}`, (match[2] || '').length, currency) : '—';
}

export function dateTime(value) {
  if (!value) return '—';
  const date = new Date(value);
  return Number.isNaN(date.getTime()) ? '—' : date.toLocaleString('ru-RU');
}

export function actionKey() {
  if (window.crypto?.randomUUID) return window.crypto.randomUUID();
  const bytes = new Uint8Array(16);
  window.crypto.getRandomValues(bytes);
  return Array.from(bytes, value => value.toString(16).padStart(2, '0')).join('');
}

const labels = {
  CREATING: ['Создаётся', 'info'], AWAITING_PAYMENT: ['Ожидает оплаты', 'warning'], PAID: ['Оплачен', 'success'],
  CANCEL_PENDING: ['Отмена запрошена', 'warning'], CANCELED: ['Отменён', 'default'], FAILED: ['Отклонён', 'error'], EXPIRED: ['Истёк', 'default'],
  WAIT_CHECK: ['Нужен чек', 'warning'], WAIT_PAY: ['Ожидает оплаты', 'warning'], CHECK_UPLOAD: ['Чек доставлен', 'success'], VIDEO_UPLOAD: ['Видео доставлено', 'success'],
  STORED: ['Сохранён', 'info'], QUEUED: ['В очереди', 'warning'], DELIVERED: ['Доставлен', 'success'], REJECTED: ['Отклонён', 'error'],
  REQUESTED: ['Запрошен', 'info'], CREATED: ['Создан', 'success'], DECLINED: ['Не выдан', 'default'], UNKNOWN: ['Нужна проверка', 'warning'],
  pending: ['В очереди', 'warning'], processing: ['Обрабатывается', 'info'], delivered: ['Доставлен', 'success'], done: ['Выполнено', 'success'],
  unknown: ['Результат неизвестен', 'warning'], rejected: ['Отклонено', 'error'], dead: ['Повторы исчерпаны', 'error'], review: ['Ручная проверка', 'warning'],
};

export function StatusChip({ status }) {
  const [label, color] = labels[status] || [status || 'Нет данных', 'default'];
  return <Chip label={label} color={color} size="small" variant="outlined" />;
}
